/** PaymentSettingConfig itemKey（tenant_config） */
export const PAYMENT_SETTING_ITEM_KEY = 'paymentSetting';

/** 允許提現星期：1=週一 … 7=週日 */
export const WITHDRAW_WEEKDAY_OPTIONS = [
  { value: '1', label: '週一' },
  { value: '2', label: '週二' },
  { value: '3', label: '週三' },
  { value: '4', label: '週四' },
  { value: '5', label: '週五' },
  { value: '6', label: '週六' },
  { value: '7', label: '週日' },
];

export const DEFAULT_PAYMENT_PARAMETERS = {
  withdrawSuccessLimitTimes: 50,
  withdrawRejectLimitTimes: 50,
  withdrawMinPrice: 0,
  withdrawMaxPrice: 0,
  withdrawFee: 0,
};

export const EMPTY_PAYMENT_SETTING_FORM = {
  depositMinPrice: '',
  depositMaxPrice: '',
  withdrawSuccessLimitTimes: '',
  withdrawRejectLimitTimes: '',
  withdrawMinPrice: '',
  withdrawMaxPrice: '',
  withdrawFee: '',
  startTime: '',
  endTime: '',
  withdrawAllowDays: ['1', '2', '3', '4', '5', '6', '7'],
  withdrawNotAllowedMessage: '',
};

function toInputString(value) {
  if (value == null || value === '') {
    return '';
  }
  return String(value);
}

/** LocalTime HH:mm:ss → input[type=time] HH:mm */
export function localTimeToInput(value) {
  if (!value) {
    return '';
  }
  const text = String(value);
  return text.length >= 5 ? text.slice(0, 5) : text;
}

/** input[type=time] → API HH:mm:ss */
export function inputToLocalTime(value) {
  if (!value?.trim()) {
    return null;
  }
  return value.trim().length === 5 ? `${value.trim()}:00` : value.trim();
}

export function parseWithdrawAllowDays(value) {
  if (!value?.trim()) {
    return [];
  }
  return value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
}

export function serializeWithdrawAllowDays(days) {
  if (!Array.isArray(days) || days.length === 0) {
    return '';
  }
  return [...days].sort().join(',');
}

export function paymentSettingContentToForm(content) {
  const params = content?.paymentParametersSetting || {};
  return {
    depositMinPrice: toInputString(content?.depositMinPrice),
    depositMaxPrice: toInputString(content?.depositMaxPrice),
    withdrawSuccessLimitTimes: toInputString(
      params.withdrawSuccessLimitTimes ?? DEFAULT_PAYMENT_PARAMETERS.withdrawSuccessLimitTimes
    ),
    withdrawRejectLimitTimes: toInputString(
      params.withdrawRejectLimitTimes ?? DEFAULT_PAYMENT_PARAMETERS.withdrawRejectLimitTimes
    ),
    withdrawMinPrice: toInputString(params.withdrawMinPrice ?? DEFAULT_PAYMENT_PARAMETERS.withdrawMinPrice),
    withdrawMaxPrice: toInputString(params.withdrawMaxPrice ?? DEFAULT_PAYMENT_PARAMETERS.withdrawMaxPrice),
    withdrawFee: toInputString(params.withdrawFee ?? DEFAULT_PAYMENT_PARAMETERS.withdrawFee),
    startTime: localTimeToInput(content?.startTime),
    endTime: localTimeToInput(content?.endTime),
    withdrawAllowDays: parseWithdrawAllowDays(content?.withdrawAllowDays),
    withdrawNotAllowedMessage: content?.withdrawNotAllowedMessage || '',
  };
}

function parseOptionalNumber(value) {
  if (value === '' || value == null) {
    return null;
  }
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
}

function parseOptionalInteger(value, fallback = null) {
  if (value === '' || value == null) {
    return fallback;
  }
  const num = Number.parseInt(String(value), 10);
  return Number.isNaN(num) ? fallback : num;
}

export function paymentSettingFormToContent(form) {
  return {
    depositMinPrice: parseOptionalNumber(form.depositMinPrice),
    depositMaxPrice: parseOptionalNumber(form.depositMaxPrice),
    startTime: inputToLocalTime(form.startTime),
    endTime: inputToLocalTime(form.endTime),
    withdrawAllowDays: serializeWithdrawAllowDays(form.withdrawAllowDays),
    withdrawNotAllowedMessage: form.withdrawNotAllowedMessage?.trim() || '',
    paymentParametersSetting: {
      withdrawSuccessLimitTimes: parseOptionalInteger(
        form.withdrawSuccessLimitTimes,
        DEFAULT_PAYMENT_PARAMETERS.withdrawSuccessLimitTimes
      ),
      withdrawRejectLimitTimes: parseOptionalInteger(
        form.withdrawRejectLimitTimes,
        DEFAULT_PAYMENT_PARAMETERS.withdrawRejectLimitTimes
      ),
      withdrawMinPrice: parseOptionalNumber(form.withdrawMinPrice) ?? 0,
      withdrawMaxPrice: parseOptionalNumber(form.withdrawMaxPrice) ?? 0,
      withdrawFee: parseOptionalNumber(form.withdrawFee) ?? 0,
    },
  };
}

export function toggleWithdrawDay(days, dayValue) {
  const set = new Set(days || []);
  if (set.has(dayValue)) {
    set.delete(dayValue);
  } else {
    set.add(dayValue);
  }
  return [...set].sort();
}
